import loadable from '@loadable/component';
import { WithLazyHydration } from '../../WithLazyHydration';

const AmbientPlayerModuleLoadable = loadable(
  () => import('./AmbientPlayerModule'),
  {
    resolveComponent: components => components.AmbientPlayerModule
  }
);

export const AmbientPlayerModule = WithLazyHydration(
  AmbientPlayerModuleLoadable,
  {
    name: 'AmbientPlayerModule'
  }
);
